const validate = (value) => {
  let result = false
  if (typeof value === 'number') {
    value = value.toString()
  } else if (typeof value !== 'string') {
    value = ''
  }
  if (!!value.length && value.length === 9) {
    result = true
  }
  return result
}

export default {
  validate
}
